import styled from "styled-components";
import { Button, Input } from "reactstrap";

export const ProgressBar = styled.div`
  width: ${(props) => props.strength}%;
  height: 15px;
  border-radius: 50px;
  background-color: ${(props) => {
    if (props.strength === 0) return "#ccc"; // Barra vazia (sem senha)
    if (props.strength < 50) return "red"; // Menos de 50% força -> vermelho
    if (props.strength < 75) return "orange"; // Entre 50% e 74% -> laranja
    if (props.strength < 100) return "yellow"; // Entre 75% e 99% -> amarelo
    return "green"; // Força 100% -> verde
  }};
  transition:
    width 0.5s ease-in-out,
    background-color 0.5s ease-in-out;
`;

export const ProgressBarWrapper = styled.div`
  margin-top: 15px;
  width: 100%;
  border: 1px solid #cccccc85; /* Borda fina e cinza */
  box-sizing: border-box;
  border-radius: 50px;
  /*   box-shadow: 1px 1px 1px 1px rgba(0.1, 0.1, 0.1, 0.1); */
`;

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f2f5;
  padding: 20px;
  box-sizing: border-box;
  position: relative; /* Necessário para centralizar a logo corretamente */
`;

export const Form = styled.div`
  width: 100%;
  max-width: 400px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    color: #0c2b6e;
    font-family: "Raleway", sans-serif;
    margin: 30px 0;
    font-weight: 400;
    font-size: 22px; /* Ajusta o tamanho da fonte para telas menores */
  }

  /* Ajuste dos títulos responsivos */
  @media (max-width: 768px) {
    padding: 15px; /* Diminui o padding em telas menores */
    max-width: 90%; /* Garante que o formulário ocupe mais espaço em telas menores */
  }

  @media (max-width: 480px) {
    h3 {
      font-size: 18px; /* Diminui o tamanho da fonte ainda mais em telas muito pequenas */
    }
  }
`;

export const LogoImage = styled.img`
  position: absolute; /* Logo fixa na parte inferior */
  bottom: 10px; /* Distância da parte inferior */
  left: 50%; /* Centraliza a logo horizontalmente */
  transform: translateX(-50%); /* Centraliza a logo */
  width: 220px; /* Tamanho inicial da logo */

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    width: 180px; /* Ajusta o tamanho da logo para telas menores */
  }

  @media (max-width: 480px) {
    width: 150px; /* Ajusta o tamanho da logo para telas muito pequenas */
  }
`;

export const InputAuth = styled(Input)`
  height: 50px;
  width: 100%;
  border-radius: 40px;
  text-align: left;
  padding: 10px 25px;
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  font-size: 16px;

  /* Ajustes responsivos para o input */
  @media (max-width: 768px) {
    font-size: 14px; /* Diminui o tamanho da fonte para telas menores */
  }
`;

export const ButtonAuth = styled(Button)`
  width: 100%;
  padding: 10px;
  border-radius: 25px;
  font-size: 18px;
  background: linear-gradient(
    268.2deg,
    #006eb0 -5.28%,
    #00afef 100%,
    #007dc3 100%
  );
  border: none;

  /* Ajuste da responsividade no botão */
  @media (max-width: 768px) {
    font-size: 16px; /* Diminui o tamanho da fonte do botão em telas menores */
  }
`;

export const InstructionText = styled.div`
  font-size: 14px;
  color: #555;
  margin-top: 1px;
  text-align: left;

  ul {
    padding-left: 20px;
  }

  li {
    margin-bottom: 5px;
  }

  /* Responsividade para o texto de instrução */
  @media (max-width: 768px) {
    font-size: 12px; /* Diminui o tamanho da fonte */
  }
`;

export const EyeIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 18px;
  color: #555;
`;
